export enum BrowserSupport {
    SUPPORTED,
    NOT_SUPPORTED,
    UNKNOWN
}